export default { sha: 'b65cc038e3a153bd5ddea2bde70bcafe70595036', buildNumber: 'undefined' }
